import { formatPhoneNumberNL } from './formatPhoneNumberNL';

export const openWhatsappWeb = (number: string, content: string) => {
  const phoneNumber = formatPhoneNumberNL(number);

  const url = `https://api.whatsapp.com/send/?phone=${encodeURIComponent(phoneNumber)}&text=${encodeURIComponent(content)}`;

  window.open(url, '_blank')?.focus();
};
